module.exports = __webpack_public_path__ + "img/SKMJ_limit1.e7039dd8.jpg";